var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0603 3.125C16.9978 3.125 20.5603 6.14375 20.5603 10.8125C20.5603 13.925 18.0572 17.6094 13.0603 21.875C8.06343 17.6094 5.5603 13.925 5.5603 10.8125C5.5603 6.14375 9.1228 3.125 13.0603 3.125ZM18.6853 10.8125C18.6853 7.40937 16.2009 5 13.0603 5C9.91968 5 7.4353 7.40937 7.4353 10.8125C7.4353 13.0062 9.26343 15.9125 13.0603 19.3813C16.8572 15.9125 18.6853 13.0062 18.6853 10.8125ZM13.0603 12.5C12.0291 12.5 11.1853 11.6562 11.1853 10.625C11.1853 9.59375 12.0291 8.75 13.0603 8.75C14.0916 8.75 14.9353 9.59375 14.9353 10.625C14.9353 11.6562 14.0916 12.5 13.0603 12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapIconWhite);
export default __webpack_public_path__ + "static/media/map-icon-white.eee956463065ad7aaece2e0054cbb7e8.svg";
export { ForwardRef as ReactComponent };